import React, { useContext } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router';
import ModalItem from '../common/ModalItem/ModalItem';
import { Container, Hidden } from '@material-ui/core';
import SignUp from './SignUp';
import IsMobileContext from '../../common/IsMobileContext';
import { get } from 'lodash';
import { completedRoutes } from '../../common/constants';

const ContentSwitch = (props) => {
  const { desktopOption, content } = props;

  return (
    <Switch>
      {desktopOption &&
      <Route>
        {content}
      </Route>
      }
    </Switch>
  );
};

function SignUpModalItem() {
  const isMobileDesign = useContext(IsMobileContext);
  const location = useLocation();
  const history = useHistory();
  const currentUrl = get(location, 'state.currentUrl');
  const goBackUrl = get(location, 'state.goBackUrl');
  const withLogo = get(location, 'state.withLogo');

  const content = (
    <Container>
      <SignUp pageType withLogo={withLogo} />
    </Container>
  );

  const handleClickArrowBack = () => {
    if (!currentUrl) {
      history.replace(completedRoutes.userTasks)
    } else {
      history.replace(goBackUrl || currentUrl, { ...location.state });
    }
  };

  return (
    <ModalItem handleClose={handleClickArrowBack}>
      <>
        <Hidden mdUp>
          {content}
        </Hidden>
        <ContentSwitch desktopOption={!isMobileDesign} content={content} />
      </>
    </ModalItem>
  );
}

export default SignUpModalItem;
